export default "__VITE_ASSET__BFm_M7Hi__"